import type { RouteRecordRaw } from 'vue-router'

export const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@features/auth/pages/UserSelectPage.vue')
  },
  {
    path: '/goals',
    name: 'goals',
    component: () => import('@features/goals/pages/GoalsPage.vue')
  },
  {
    path: '/',
    name: 'home',
    redirect: '/todo'
  },
  {
    path: '/todo',
    name: 'todo',
    component: () => import('@features/todo/pages/TodoListPage.vue')
  },
  {
    path: '/schedule',
    name: 'schedule',
    component: () => import('@features/schedule/pages/SchedulePage.vue')
  },
  {
    path: '/schedule/status/:status',
    name: 'status-tasks',
    component: () => import('@features/schedule/pages/StatusTasksPage.vue')
  },
  {
    path: '/anniversaries',
    name: 'anniversaries',
    component: () => import('@features/anniversaries/pages/AnniversaryListPage.vue')
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@features/notifications/pages/NotificationListPage.vue')
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: () => import('@features/calendar/pages/CalendarPage.vue')
  },
  {
    path: '/meeting',
    name: 'meeting',
    component: () => import('@features/meeting/pages/MeetingListPage.vue')
  },
  {
    path: '/meeting/:id',
    name: 'meeting-detail',
    component: () => import('@features/meeting/pages/MeetingDetailPage.vue')
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import('@features/meeting/pages/TaskBoardPage.vue')
  },
  {
    path: '/agent-hub',
    name: 'agent-hub',
    component: () => import('@features/meeting/pages/AgentHubPage.vue')
  },
  {
    path: '/mailbox',
    name: 'mailbox',
    component: () => import('@features/mailbox/pages/MailboxPage.vue')
  },
  {
    path: '/diary',
    name: 'diary',
    component: () => import('@features/diary/pages/DiaryPage.vue')
  },
  {
    path: '/review',
    name: 'review',
    component: () => import('@features/review/pages/ReviewPage.vue')
  },
  {
    path: '/memo',
    name: 'memo',
    component: () => import('@features/memo/pages/MemoPage.vue')
  },
  {
    path: '/health',
    name: 'health',
    redirect: '/health/data'
  },
  {
    path: '/health/strength',
    name: 'health-strength',
    component: () => import('@features/strength/pages/StrengthPage.vue')
  },
  {
    path: '/health/running',
    name: 'health-running',
    component: () => import('@features/running/components/RunningView.vue')
  },
  {
    path: '/health/data',
    name: 'health-data',
    component: () => import('@features/health/pages/HealthPage.vue')
  },
  {
    path: '/health/body',
    name: 'health-body',
    component: () => import('@features/bodymetrics/pages/BodyMetricsPage.vue')
  },
  {
    path: '/health/body/:id',
    name: 'bodymetrics-detail',
    component: () => import('@features/bodymetrics/pages/BodyMetricDetailPage.vue')
  },
  {
    path: '/growth',
    name: 'growth',
    component: () => import('@features/growth/pages/GrowthPage.vue')
  },
  {
    path: '/migration',
    name: 'migration',
    component: () => import('@features/migration/pages/MigrationCheckPage.vue')
  },
  {
    path: '/tools',
    name: 'tools',
    component: () => import('@features/misc/pages/MiscPage.vue')
  },
  {
    path: '/packing',
    name: 'packing',
    component: () => import('@features/packing/pages/PackingPage.vue')
  },
  {
    path: '/travel',
    name: 'travel',
    component: () => import('@features/travel/pages/TravelListPage.vue')
  },
  {
    path: '/travel/footprint',
    name: 'travel-footprint',
    component: () => import('@features/travel/pages/TravelFootprintPage.vue')
  },
  {
    path: '/travel/:id',
    name: 'travel-detail',
    component: () => import('@features/travel/pages/TravelDetailPage.vue')
  },
  {
    path: '/smoke',
    name: 'smoke',
    component: () => import('@features/todo/pages/SmokePage.vue')
  },
  {
    path: '/bodymetrics',
    name: 'bodymetrics',
    redirect: '/health/body'
  },
  {
    path: '/bodymetrics/:id',
    name: 'bodymetrics-detail-legacy',
    redirect: to => `/health/body/${String(to.params.id)}`
  },
  {
    path: '/training',
    name: 'training',
    redirect: '/health/strength'
  },
  {
    path: '/wechat-export',
    name: 'wechat-export',
    component: () => import('@features/wechat-export/pages/WechatExportPage.vue')
  }
]
